export default "__VITE_ASSET__CtSF5qxb__"